import React, { useState, useEffect } from "react"
import { Link } from "gatsby"

import ScrollAnimation from 'react-animate-on-scroll';
import HTMLReactParser from 'html-react-parser';

import { Container, Row, Col, Tabs, Tab, Form, Button, Select } from "react-bootstrap"

import Form_Rightside from "./Form_Rightside"
import ContactForm from "../forms/individual-contact-form"

import $ from 'jquery'

import "./ContactFormBottom.scss"
// Header component
import { useStaticQuery, graphql } from "gatsby"

import { useLocation } from "@reach/router";

const Connect = (props) => {

    const data = useStaticQuery(graphql`
    query contactForm {  
      glstrapi{

        globalModule {
            Contact_Form {
              Content
              Title
              May_Also_CTA {
                CTA_Label
                CTA_Icon {
                  url
                  alternativeText
                }
                CTA_Link
                Icon_ClassName
              }
            }
        }

      }
    }
  `)

  var global_module = data.glstrapi?.globalModule;

  var department = (props.Menu_Link && props.Menu_Link.Main_Parent !== null) ? props.Menu_Link.Main_Parent.Label : props.Menu_Link?.Label;
  var type = props.Menu_Link && props.Menu_Link?.Type;
  var sub_type = props.Menu_Link && props.Menu_Link?.Sub_Type;
  //console.log("Menu_Link", department)
  
  var to_user_id = props?.Menu_Link?.Form_User_ID ? props?.Menu_Link?.Form_User_ID : '';
  
  const location = useLocation();
  function gotohash(event) {
    var thishash = event;
      $('html, body').animate({
        scrollTop: 1000
      }, 100);
  }
  //console.log(location.hash.indexOf("#contact_office"))
  if(typeof window !== 'undefined' && location.href.indexOf("#contact_office")>=0) {
    gotohash('#contact_office')
  }
  //console.log("props_form_name", props.form_name);

    return (
        <React.Fragment>
            <section className="connect-us" id="contact_office">
                <Container>
                    <Row>
                        <Col>
                            <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                {
                                    global_module.Contact_Form &&                                 
                                    <div className="connect-wrapper">
                                        <div className="contact-form">
                                            {
                                                props.Module && props.Module.Title ? <h2>{props.Module.Title}</h2> : <h2>{global_module.Contact_Form.Title}</h2>
                                            }

                                            {
                                                props.Module && props.Module.Content ? <p>{HTMLReactParser(props.Module.Content)}</p> : global_module.Contact_Form.Content && HTMLReactParser(global_module.Contact_Form.Content)
                                            }
                                            
                                            <ContactForm form_name={props.form_name} formLabel={props.formLabel} to_email_id={props.to_email_id} to_user_id={props.to_user_id ? props.to_user_id : to_user_id} enable_mail={props.enable_mail} type={props.type ? props.type: type} sub_type={props.sub_type ? props.sub_type :  sub_type} page_url={location.href} subject={props.subject} Alias={props.Alias}/>
                                        </div>

                                        {
                                            props.Module && props.Module.May_Also_CTA_Buttons && props.Module.May_Also_CTA_Buttons.length > 0 
                                            ? 
                                                <Form_Rightside Data={props.Module.May_Also_CTA_Buttons} openSearch={props.openSearch} department={department} type={props.type ? props.type: type} sub_type={props.sub_type ? props.sub_type :  sub_type} to_user_id={props.to_user_id ? props.to_user_id : to_user_id} />
                                            : 
                                                global_module.Contact_Form.May_Also_CTA && global_module.Contact_Form.May_Also_CTA.length > 0 && 
                                                <Form_Rightside Data={global_module.Contact_Form.May_Also_CTA} openSearch={props.openSearch} department={department} type={props.type ? props.type: type} sub_type={props.sub_type ? props.sub_type :  sub_type} to_user_id={props.to_user_id ? props.to_user_id : to_user_id} />
                                        }
                                    </div>
                                }                                
                            </ScrollAnimation>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Connect;
